import React from 'react';
import { ExternalLink, Phone, Mail, Globe, Star } from 'lucide-react';
import { resolveImageUrl } from '../../lib/utils';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export const ServiceCard = ({ service }) => {
  const { id, name, description, category, website_url, phone, email, image_url, is_featured } = service;

  return (
    <div
      className="group bg-white border border-[#D6D2C4] rounded-sm overflow-hidden card-hover"
      data-testid={`service-card-${id}`}
    >
      <div className="aspect-[16/9] relative overflow-hidden">
        <img
          src={resolveImageUrl(image_url) || 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&q=80'}
          alt={name}
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {is_featured && (
          <Badge className="absolute top-3 right-3 bg-[#DFAF3A] text-[#1A1A1A] font-['Montserrat'] text-[10px] uppercase tracking-wider">
            <Star size={10} className="mr-1" fill="currentColor" />
            Recomendado
          </Badge>
        )}
        <Badge className="absolute top-3 left-3 bg-[#0F5A34] text-white font-['Montserrat'] text-[10px] uppercase tracking-wider capitalize">
          {category}
        </Badge>
      </div>
      
      <div className="p-4">
        <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#1A1A1A] mb-2 group-hover:text-[#0F5A34] transition-colors">
          {name}
        </h3>
        <p className="text-[#5C5C5C] font-['Inter'] text-sm mb-4 line-clamp-3">
          {description}
        </p>
        
        <div className="space-y-2 mb-4">
          {phone && (
            <a
              href={`tel:${phone}`}
              className="flex items-center gap-2 text-[#5C5C5C] hover:text-[#0F5A34] text-sm font-['Inter'] transition-colors"
            >
              <Phone size={14} />
              {phone}
            </a>
          )}
          {email && (
            <a
              href={`mailto:${email}`}
              className="flex items-center gap-2 text-[#5C5C5C] hover:text-[#0F5A34] text-sm font-['Inter'] transition-colors"
            >
              <Mail size={14} />
              {email}
            </a>
          )}
        </div>
        
        {website_url && (
          <a href={website_url} target="_blank" rel="noopener noreferrer">
            <Button className="w-full bg-[#0F5A34] hover:bg-[#0A3F24] text-white font-['Montserrat'] text-sm">
              <Globe size={14} className="mr-2" />
              Visitar Site
              <ExternalLink size={12} className="ml-2" />
            </Button>
          </a>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
